import { render, staticRenderFns } from "./recentdoc.vue?vue&type=template&id=d7a913c6&scoped=true"
import script from "./recentdoc.vue?vue&type=script&lang=js"
export * from "./recentdoc.vue?vue&type=script&lang=js"
import style0 from "./recentdoc.vue?vue&type=style&index=0&id=d7a913c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a913c6",
  null
  
)

export default component.exports